import React from 'react';
import { useSelector } from 'react-redux';
import { Stack, Typography, Button, alpha, useTheme, Box } from '@mui/material';
import { ImageRounded, TableChartRounded, AddCircleOutlineRounded } from '@mui/icons-material';

const InlineToolbar = ({ onAddImage, onAddTable, onAddMore, visible, showPrompt = true, ...props }) => {
    const theme = useTheme();

    if (!visible) return null;

    const buttonStyle = {
        borderRadius: '20px',
        textTransform: 'none',
        px: 1.5,
        py: 0.5,
        border: '1px solid',
        borderColor: alpha(theme.palette.divider, 0.2),
        color: theme.palette.text.primary,
        bgcolor: 'background.paper',
        fontSize: '0.8rem',
        fontWeight: 500,
        '&:hover': {
            bgcolor: alpha(theme.palette.action.hover, 0.5),
            borderColor: alpha(theme.palette.divider, 0.4),
        },
        '& .MuiButton-startIcon': {
            mr: 0.5,
            color: 'text.secondary'
        }
    };

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            {...props}
            sx={{
                width: '100%',
                zIndex: 10,
                flexWrap: 'wrap',
                py: 0.5,
                ...props.sx
            }}
        >
            <Button
                variant="text"
                size="small"
                startIcon={<ImageRounded sx={{ fontSize: '16px !important' }} />}
                onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); onAddImage(); }}
                sx={{ ...buttonStyle, border: 'none', px: 1, pointerEvents: 'auto' }}
            >
                Add image
            </Button>

            <Typography variant="caption" sx={{ color: alpha(theme.palette.divider, 0.5), mx: 0.5 }}>|</Typography>

            <Button
                variant="text"
                size="small"
                startIcon={<TableChartRounded sx={{ fontSize: '16px !important' }} />}
                onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); onAddTable(); }}
                sx={{ ...buttonStyle, border: 'none', px: 1, pointerEvents: 'auto' }}
            >
                Add table
            </Button>

            <Typography variant="caption" sx={{ color: alpha(theme.palette.divider, 0.5), mx: 0.5 }}>|</Typography>

            <Button
                variant="text"
                size="small"
                startIcon={<AddCircleOutlineRounded sx={{ fontSize: '16px !important' }} />}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onAddMore(e); }}
                sx={{ ...buttonStyle, border: 'none', px: 1, pointerEvents: 'auto' }}
            >
                Add more blocks
            </Button>
        </Stack>
    );
};

export default InlineToolbar;
